// Copyright 1999-2023. Plesk International GmbH. All rights reserved.

import { forwardRef } from 'react';
import { useSqueeze } from '../../hooks';
/** Render-less useSqueeze wrapper */
const Squeezer = /*#__PURE__*/forwardRef((props, ref) => {
  useSqueeze({
    ref: ref,
    ...props
  });
  return null;
});
Squeezer.displayName = 'Squeezer';
export default Squeezer;